import { HttpClient, HttpParams } from "@angular/common/http";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProyectoService {
  // De layout
  @Output() disparadorDeEdificio: EventEmitter<any> = new EventEmitter();
  @Output() disparadorDeLayout: EventEmitter<any> = new EventEmitter();
  @Output() reset: EventEmitter<any> = new EventEmitter();

  url = environment.URL + "/api/4s/";

  constructor(private http: HttpClient) {}

  getProyecto(id_project: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + "projects/" + id_project).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getAmenities(id_proyecto: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.url + "project-amenities?project_id=" + id_proyecto + "&real_estate_id=" + id_real_estate)
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getBuilding(id_proyecto: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + "buildings?project_id=" + id_proyecto + "&real_estate_id=" + id_real_estate).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLayouts(id_proyecto: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + "layouts?project_id=" + id_proyecto + "&real_estate_id=" + id_real_estate).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLayout(id_layout: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + "layouts/" + id_layout + "?real_estate_id=" + id_real_estate).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getEstateProject(id_estate: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + "estates/" + id_estate + "?real_estate_id=" + id_real_estate).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  indexUbicationsEstate(id_layout: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.url + "ubications-estate?layout_id=" + id_layout + "&real_estate_id=" + id_real_estate)
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  indexUbicationLayout(id_building: Number, id_real_estate: Number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.url + "ubications-layout?building_id=" + id_building + "&real_estate_id=" + id_real_estate)
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
